module.exports = __webpack_public_path__ + "img/evaluate-common.8e36b158.png";